
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","version":"1.1","viewBox":"0 0 870 100"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('style',[_v('.cls-1{fill:#0f2815;stroke-width:0}')])]),_c('path',{staticClass:"cls-1",attrs:{"d":"M665 100h40c27.61 0 50-22.39 50-50S732.61 0 705 0H595c-27.61 0-50 22.39-50 50s22.39 50 50 50h70Zm-40-50c0 16.57-13.43 30-30 30s-30-13.43-30-30 13.43-30 30-30 30 13.43 30 30Z"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"370","cy":"50","r":"5"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"820","cy":"50","r":"5"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"50","cy":"50","r":"5"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M155 55V45h5c2.76 0 5 2.24 5 5v5h-10Zm110 0-5-10h10l-5 10z"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"485","cy":"50","r":"5"}})])
          )
        }
      }
    